import { combineReducers } from 'redux'
import {
  ROLE_GET_LOADING,
  ROLE_GET_ERROR,
  ROLE_GET_SUCCESS,

  ROLE_VIEW_ERROR,
  ROLE_VIEW_LOADING,
  ROLE_VIEW_SUCCESS,

  ROLE_ADD_ERROR,
  ROLE_ADD_LOADING,
  ROLE_ADD_SUCCESS,

  ROLE_DELETE_ERROR,
  ROLE_DELETE_LOADING,
  ROLE_DELETE_SUCCESS,
  ROLE_EDIT_ERROR,
  ROLE_EDIT_LOADING,
  ROLE_EDIT_SUCCESS,
  PO_DISABLE_ENABLE_ERROR,
  PO_DISABLE_ENABLE_LOADING,
  PO_DISABLE_ENABLE_SUCCESS
} from '../actions/constant'

const purchaseEnableDisablePOError = (state = false, action) => {
  switch (action.type) {
    case PO_DISABLE_ENABLE_ERROR:
      return action.purchaseEnableDisablePOError
    default:
      return state
  }
}

const purchaseEnableDisablePOLoading = (state = false, action) => {
  switch (action.type) {
    case PO_DISABLE_ENABLE_LOADING:
      return action.purchaseEnableDisablePOLoading
    default:
      return state
  }
}

const purchaseEnableDisablePOSuccess = (state = false, action) => {
  switch (action.type) {
    case PO_DISABLE_ENABLE_SUCCESS:
      return action.purchaseEnableDisablePOSuccess
    default:
      return state
  }
}

const purchaseEnableDisablePO = (state = [], action) => {
  switch (action.type) {
    case PO_DISABLE_ENABLE_SUCCESS:
      return action.purchaseEnableDisablePO
    default:
      return state
  }
}

const roleGetError = (state = false, action) => {
  switch (action.type) {
    case ROLE_GET_ERROR:
      return action.roleGetError
    default:
      return state
  }
}

const roleGetLoading = (state = false, action) => {
  switch (action.type) {
    case ROLE_GET_LOADING:
      return action.roleGetLoading
    default:
      return state
  }
}

const roleGetSuccess = (state = false, action) => {
  switch (action.type) {
    case ROLE_GET_SUCCESS:
      return action.roleGetSuccess
    default:
      return state
  }
}

const roles = (state = [], action) => {
  switch (action.type) {
    case ROLE_GET_SUCCESS:
      return action.roles
    default:
      return state
  }
}

const roleViewLoading = (state = false, action) => {
  switch (action.type) {
    case ROLE_VIEW_LOADING:
      return action.roleViewLoading
    default:
      return state
  }
}

const roleViewError = (state = false, action) => {
  switch (action.type) {
    case ROLE_VIEW_ERROR:
      return action.roleViewError
    default:
      return state
  }
}

const roleViewSuccess = (state = false, action) => {
  switch (action.type) {
    case ROLE_VIEW_SUCCESS:
      return action.roleViewSuccess
    default:
      return state
  }
}

const role = (state=[], action) => {
  switch (action.type) {
    case ROLE_VIEW_SUCCESS:
      return action.role
    default:
      return state
  }
}

const roleAddError = (state = false, action) => {
  switch (action.type) {
    case ROLE_ADD_ERROR:
      return action.roleAddError
    default:
      return state
  }
}

const roleAddLoading = (state = false, action) => {
  switch (action.type) {
    case ROLE_ADD_LOADING:
      return action.roleAddLoading
    default:
      return state
  }
}

const roleAddSuccess = (state = false, action) => {
  switch (action.type) {
    case ROLE_ADD_SUCCESS:
      return action.roleAddSuccess
    default:
      return state
  }
}

const roleEditError = (state = false, action) => {
  switch (action.type) {
    case ROLE_EDIT_ERROR:
      return action.roleEditError
    default:
      return state
  }
}

const roleEditLoading = (state = false, action) => {
  switch (action.type) {
    case ROLE_EDIT_LOADING:
      return action.roleEditLoading
    default:
      return state
  }
}

const roleEditSuccess = (state = false, action) => {
  switch (action.type) {
    case ROLE_EDIT_SUCCESS:
      return action.roleEditSuccess
    default:
      return state
  }
}

const roleDeleteError = (state = false, action) => {
  switch (action.type) {
    case ROLE_DELETE_ERROR:
      return action.roleDeleteError
    default:
      return state
  }
}

const roleDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case ROLE_DELETE_LOADING:
      return action.roleDeleteLoading
    default:
      return state
  }
}

const roleDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case ROLE_DELETE_SUCCESS:
      return action.roleDeleteSuccess
    default:
      return state
  }
}

const roleReducer = combineReducers({
  roleGetError,
  roleGetLoading,
  roleGetSuccess,
  roles,

  roleViewLoading,
  roleViewError,
  roleViewSuccess,
  role,

  roleAddError,
  roleAddLoading,
  roleAddSuccess,

  roleDeleteError,
  roleDeleteLoading,
  roleDeleteSuccess,

  roleEditError,
  roleEditLoading,
  roleEditSuccess,

  purchaseEnableDisablePOError,
  purchaseEnableDisablePOSuccess,
  purchaseEnableDisablePOLoading,
  purchaseEnableDisablePO
})

export default roleReducer
